import { Component, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';

@Component({
    selector: 'app-mm-menu-footer',
    templateUrl: './mm-menu-footer.component.html',
    styleUrls: ['./mm-menu-footer.component.scss'],
})
export class MmMenuFooterComponent {

    public modelLocator: ModelLocatorService;
    protected router: Router;

    constructor(
        injector: Injector,
        modelLocatorService: ModelLocatorService,
        public platform: Platform
    ) {
        this.router = injector.get(Router);
        this.modelLocator = modelLocatorService;
    }

    touchGoToRoute(rota: string) {
        this.router.navigate([rota]);
    };

}